module.exports = __webpack_public_path__ + "media/tip.8f0ca6f9.mp3";